<template>
    <el-dialog title="选择产品编码" :visible.sync="selectCodeDialog" width="560px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_select_code_wrap">
            <div class="product_select_code_top">
                <el-input v-if="stockType != 'transfer_in'" size="small" v-model="keywords" placeholder="请输入产品编码"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
                <div class="select_num">已选：<span>{{multipleSelection.length}}个</span></div>
            </div>
            <div class="product_select_code_bottom">
                <el-table class="custom_table" :data="codeData" border max-height="480px" ref="multipleTable" row-key="code"  @selection-change="handleSelectionChange">
                    <el-table-column :resizable="false" type="selection"   align="center"  width="45" :reserve-selection="true"   :selectable="isSelectable"></el-table-column>
                    <el-table-column label="产品编码" prop="code" show-overflow-tooltip min-width="285px">
                        <template slot-scope="{row}">
                            <el-tooltip placement="top" content="已报废" >
                              <span v-if="row.status == 2" class="handle_icon_wrap handle_icon_danger_wrap mr_8">
                                  <i style="font-size: 14px;color: rgba(228, 65, 68, 1)" class="el-icon-warning-outline"></i>
                              </span>
                            </el-tooltip>
                          <span v-text="row.code"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="product_select_code_pagination" v-if="stockType != 'transfer_in' && stockType != 'transfer_in_cancel'">
                <el-pagination background
                               size="mini"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="pagination.pageNum"
                               :page-sizes="pagination.pageSizes"
                               :page-size="pagination.pageSize"
                               :layout="pagination.layout"
                               :pager-count="5"
                               :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {  chooseCode } from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "select_code",
    props: {
        selectCodeDialog: {
            type: Boolean,
            default: false
        },
        productInfo: {
            type: Object,
            default: ()=>{}
        },
        selectedCodeData: {
            type: Array,
            default: ()=> []
        },
        maxChangeNum: {
            type: Number,
            default: 0
        },
        relatedId: {
            type: Number,
            default: 0
        },
        stockType: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            keywords:'',
            BtnDisabled:false,
            lastTimeCode:[], //上一次选择的编码
            codeData:[],
            multipleSelection:[]
        }
    },
    mixins: [pagination],
    created() {

        if(this.stockType != 'transfer_in' && this.stockType != 'transfer_in_cancel'){
            if(this.productInfo.code_list){
                this.lastTimeCode = JSON.parse(JSON.stringify(this.productInfo.code_list))
            }
            this.getTableData()
        }else{
            if(this.productInfo.code_list){
                this.lastTimeCode = this.productInfo.code_list.map((item)=>{
                    return {
                        code:item
                    }
                })
            }
        }
    },
    mounted() {
        if(this.stockType != 'transfer_in' &&  this.stockType != 'transfer_in_cancel'){
            this.$nextTick(()=>{
                this.multipleSelection = JSON.parse(JSON.stringify(this.productInfo.code_list))
                this.multipleSelection.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            })
        }else{
           this.productInfo.all_code_list.map((item,key)=>{
                let json = {
                    code:item,
                    id:key
                }
                this.codeData.push(json)
                if(this.productInfo.code_list.findIndex(find => find == item) > -1){
                    this.multipleSelection.push(json)
                }
            })
            this.$nextTick(()=>{
                this.multipleSelection.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            });
        }



    },
    methods: {
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        isSelectable(row, index) {
            // 采购退货
            if(row.hasOwnProperty('code2') &&  (row.code2 == null || row.code2 == 'null')){
                return false
            }
            // 别的产品选择了就不能再选了
            if(this.selectedCodeData.find(find => find.code == row.code)){
                return false
            }
            if(this.maxChangeNum == 0){
                return  true
            }
            return this.multipleSelection.find(find => find.code == row.code) ? true : this.multipleSelection.length < this.maxChangeNum
        },
        handleSelectionChange(selection){

            if(this.maxChangeNum > 0){
                if (selection.length > this.maxChangeNum) {
                    this.$refs.multipleTable.clearSelection();
                    selection.splice(this.maxChangeNum); // Limit to 5 items
                    selection.forEach(item => {
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    });
                }
            }

            let result = selection.filter(item2 => {
                // 检查 status 是否为 2  不包含上一次选择的编码

                if (item2.status === 2 && !this.lastTimeCode.find(find => find.code === item2.code)) {
                    // 查找是否在 this.multipleSelection 中存在相同的 code 和 id
                    return !this.multipleSelection.some(item1 => item1.code === item2.code && item1.id === item2.id);
                }
                return false; // 如果 status 不是 2，则不需要返回这个对象
            });
            this.lastTimeCode = this.lastTimeCode.filter(item => {
                return !selection.find(find => find.code === item.code)
            })
            if(result && result.length>0){
                const h = this.$createElement;
                this.$msgbox({
                    title: '异常编码',
                    message: h('div', null, [
                        h('span', null, '您当前选择出库的编码为异常状态是否选中！'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:  '是',
                    cancelButtonText: '否',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass:'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    this.multipleSelection = selection;

                }).catch(() => {
                    let selectData = selection.filter(item1 => {
                        // 使用 some 检查 item1 是否在 data2 中
                        return !result.some(item2 => item1.code === item2.code && item1.id === item2.id && item1.status === item2.status);
                    });
                    result.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row,false);
                    });
                    this.multipleSelection = selectData;

                })
            }else{
                this.multipleSelection = selection;

            }

        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.keywords,
                product_name:this.productInfo.name,
                sku_id:this.productInfo.sku_id,
                stock_id:this.productInfo.stock_id,
                stock_type:this.stockType
            }
            if(this.relatedId){
                postData.related_id = this.relatedId
            }
            if(this.productInfo && this.productInfo.related_detail_id){
                postData.related_detail_id = this.productInfo.related_detail_id
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    this.codeData = list
                    this.pagination.total = total
                }else{
                    this.btnDisabled = false
                }
            })
        },
        handleDialogClose() {
            this.$emit("update:selectCodeDialog", false)
        },
        handleDialogConfirm() {
            this.$emit("success", this.multipleSelection)
            this.$emit("update:selectCodeDialog", false)
        },

    }
}
</script>
<style  lang="scss" scoped>
::v-deep .el-pagination__jump{
    display: none !important;
}
.mr_8{
    margin-right: 8px;
}
    @import "@/styles/inventory_management.scss";
</style>